import { NarrativeTemplate } from "../../shared/interfaces/ReportGenReport";

// Resolved by the generation API on its own — unlike every other option in the
// picker, it has no station template row behind it.
export const FREE_FORM_NARRATIVE_TEMPLATE_ID = "free_form_narrative";

const FREE_FORM_NARRATIVE: NarrativeTemplate = {
  template: {
    name: "Free Form Narrative",
    content: "",
    stationId: "",
    templateId: FREE_FORM_NARRATIVE_TEMPLATE_ID,
    arguments: {},
  },
  examples: [],
};

/** Default selection on the Generate Report page. */
export const DEFAULT_REPORT_TYPE = FREE_FORM_NARRATIVE;

/**
 * The template id to send to the generation API. Free Form Narrative's id is a
 * local sentinel for the picker only — no station template row backs it, so it
 * resolves to `undefined` and the request carries no template at all.
 */
export function resolveNarrativeTemplateId(
  reportType: NarrativeTemplate
): string | undefined {
  const { templateId } = reportType.template;
  return templateId === FREE_FORM_NARRATIVE_TEMPLATE_ID ? undefined : templateId;
}

/**
 * The report-type picker's options: Free Form Narrative first, then the
 * station's templates from `/templates` (General Report among them, carrying
 * its example narrative). Should `/templates` ever return Free Form Narrative
 * too, the fetched copy replaces the local one instead of listing it twice.
 */
export function mergeReportTypes(stationTemplates: NarrativeTemplate[]): NarrativeTemplate[] {
  const isFreeForm = (type: NarrativeTemplate) =>
    type.template.templateId === FREE_FORM_NARRATIVE_TEMPLATE_ID;

  return [
    stationTemplates.find(isFreeForm) ?? FREE_FORM_NARRATIVE,
    ...stationTemplates.filter((type) => !isFreeForm(type)),
  ];
}
